<template>
  <div>
    <b-modal id="settings-modal" title="Settings" size="xl">
      <div class>
        <h3>Table settings</h3>
        <table class="game-table">
          <thead>
            <th>Name</th>
            <th>Header</th>
            <th>Table</th>
            <th>Order</th>
            <th>Export</th>
            <th>Color</th>
            <th></th>
            <th>
              <div v-on:click="addTableRow()">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-plus"
                  width="44"
                  height="44"
                  viewBox="0 0 24 24"
                  stroke-width="1"
                  stroke="#F44336"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" />
                  <line x1="12" y1="5" x2="12" y2="19" />
                  <line x1="5" y1="12" x2="19" y2="12" />
                </svg>
              </div>
            </th>
          </thead>
          <tbody>
            <tr v-bind:key="index" v-for="(service, index) in orderedTables">
              <td v-if="service.edit == false">{{ service.name }}</td>
              <td v-if="service.edit == false">{{ service.value }}</td>
              <td v-if="service.edit == false">{{ service.table }}</td>
              <td v-if="service.edit == false">{{ service.order }}</td>
              <td v-if="service.edit == false">
                <input
                  type="checkbox"
                  id="checkbox"
                  disabled="disabled"
                  v-model="service.export"
                />
              </td>
              <td v-if="service.edit == false">
                <input
                  type="text"
                  v-model="service.color"
                  name="color"
                  id="color"
                  class="color-input"
                  :style="{ borderColor: service.color }"
                />
              </td>
              <td
                v-if="service.edit == false"
                v-on:click="service.edit = !service.edit"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-edit"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#a4c719"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" />
                  <path
                    d="M9 7 h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"
                  />
                  <path d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3" />
                  <line x1="16" y1="5" x2="19" y2="8" />
                </svg>
              </td>
              <td
                v-if="service.edit == false"
                v-on:click="removeTable(service)"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-trash"
                  width="32"
                  height="32"
                  viewBox="0 0 24 24"
                  stroke-width="1"
                  stroke="#F44336"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" />
                  <line x1="4" y1="7" x2="20" y2="7" />
                  <line x1="10" y1="11" x2="10" y2="17" />
                  <line x1="14" y1="11" x2="14" y2="17" />
                  <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                  <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                </svg>
              </td>

              <td v-if="service.edit == true">
                <input
                  v-show="service.edit == true"
                  v-model="service.name"
                  @keyup.enter="
                    service.edit = false;
                    $emit('update');
                  "
                />
              </td>
              <td v-if="service.edit == true">
                <input
                  v-show="service.edit == true"
                  v-model="service.value"
                  @keyup.enter="
                    service.edit = false;
                    $emit('update');
                  "
                />
              </td>
              <td v-if="service.edit == true">
                <input
                  v-show="service.edit == true"
                  v-model="service.table"
                  @keyup.enter="
                    service.edit = false;
                    $emit('update');
                  "
                />
              </td>
              <td v-if="service.edit == true">
                <input
                  v-show="service.edit == true"
                  v-model="service.order"
                  @keyup.enter="
                    service.edit = false;
                    $emit('update');
                  "
                />
              </td>
              <td v-if="service.edit == true">
                <input type="checkbox" id="checkbox" v-model="service.export" />
              </td>
              <td v-if="service.edit == true">
                <input
                  type="text"
                  v-model="service.color"
                  name="color"
                  id="color"
                  class="color-input"
                  :style="{ borderColor: service.color }"
                />
              </td>
              <td
                v-if="service.edit == true"
                v-on:click="service.edit = !service.edit"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="icon icon-tabler icon-tabler-device-floppy"
                  width="44"
                  height="44"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="#673AB7"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" />
                  <path
                    d="M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2"
                  />
                  <circle cx="12" cy="14" r="2" />
                  <polyline points="14 4 14 8 8 8 8 4" />
                </svg>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class>
        <h3>Relationship settings</h3>
        <table class="game-table">
          <thead>
            <th>From</th>
            <th>Relationship</th>
            <th>To</th>
          </thead>
          <tbody>
            <tr v-bind:key="index" v-for="(relation, index) in scene.rels">
              <td>{{ relation.from }}</td>
              <td>{{ relation.relationship.name }}</td>
              <td>{{ relation.to }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    scene: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  computed: {
    orderedTables: function () {
      return _.orderBy(this.scene.tables, "order");
    },
  },
  methods: {
    addTableRow: function () {
      this.scene.tables.push({
        name: "Give me a name!",
        value: "placeholder",
        id: this.scene.tables.length,
        order: this.scene.tables.length * 10,
        table: "placeholder_table",
        color: "#000000",
        edit: false,
      });
    },
    removeTable: function (service) {
      this.scene.tables = this.scene.tables.filter(
        (entry) => entry.id != service.id
      );
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Modals/SettingsModal.vue